var map = {
	"./aama.png": "./src/Containers/Play/BalloonPop/content/images/hints/aama.png",
	"./aamala.png": "./src/Containers/Play/BalloonPop/content/images/hints/aamala.png",
	"./amba.png": "./src/Containers/Play/BalloonPop/content/images/hints/amba.png",
	"./aurja.png": "./src/Containers/Play/BalloonPop/content/images/hints/aurja.png",
	"./baadar.png": "./src/Containers/Play/BalloonPop/content/images/hints/baadar.png",
	"./baaj.png": "./src/Containers/Play/BalloonPop/content/images/hints/baaj.png",
	"./baaja.png": "./src/Containers/Play/BalloonPop/content/images/hints/baaja.png",
	"./bag.png": "./src/Containers/Play/BalloonPop/content/images/hints/bag.png",
	"./bed.png": "./src/Containers/Play/BalloonPop/content/images/hints/bed.png",
	"./book.png": "./src/Containers/Play/BalloonPop/content/images/hints/book.png",
	"./bunu.png": "./src/Containers/Play/BalloonPop/content/images/hints/bunu.png",
	"./challo.png": "./src/Containers/Play/BalloonPop/content/images/hints/challo.png",
	"./chang.png": "./src/Containers/Play/BalloonPop/content/images/hints/chang.png",
	"./chata.png": "./src/Containers/Play/BalloonPop/content/images/hints/chata.png",
	"./chataki.png": "./src/Containers/Play/BalloonPop/content/images/hints/chataki.png",
	"./chithi.png": "./src/Containers/Play/BalloonPop/content/images/hints/chithi.png",
	"./chungi.png": "./src/Containers/Play/BalloonPop/content/images/hints/chungi.png",
	"./dhara (2).png": "./src/Containers/Play/BalloonPop/content/images/hints/dhara (2).png",
	"./dhara.png": "./src/Containers/Play/BalloonPop/content/images/hints/dhara.png",
	"./dharko.png": "./src/Containers/Play/BalloonPop/content/images/hints/dharko.png",
	"./fohar.png": "./src/Containers/Play/BalloonPop/content/images/hints/fohar.png",
	"./gagro.png": "./src/Containers/Play/BalloonPop/content/images/hints/gagro.png",
	"./gatta.png": "./src/Containers/Play/BalloonPop/content/images/hints/gatta.png",
	"./ghaila.png": "./src/Containers/Play/BalloonPop/content/images/hints/ghaila.png",
	"./ghanti.png": "./src/Containers/Play/BalloonPop/content/images/hints/ghanti.png",
	"./ghar.png": "./src/Containers/Play/BalloonPop/content/images/hints/ghar.png",
	"./ghee.png": "./src/Containers/Play/BalloonPop/content/images/hints/ghee.png",
	"./ghoda.png": "./src/Containers/Play/BalloonPop/content/images/hints/ghoda.png",
	"./haanga.png": "./src/Containers/Play/BalloonPop/content/images/hints/haanga.png",
	"./haat.png": "./src/Containers/Play/BalloonPop/content/images/hints/haat.png",
	"./hair.png": "./src/Containers/Play/BalloonPop/content/images/hints/hair.png",
	"./jaal.png": "./src/Containers/Play/BalloonPop/content/images/hints/jaal.png",
	"./jarayo.png": "./src/Containers/Play/BalloonPop/content/images/hints/jarayo.png",
	"./jhuppa.png": "./src/Containers/Play/BalloonPop/content/images/hints/jhuppa.png",
	"./jun.png": "./src/Containers/Play/BalloonPop/content/images/hints/jun.png",
	"./kaag.png": "./src/Containers/Play/BalloonPop/content/images/hints/kaag.png",
	"./kacho.png": "./src/Containers/Play/BalloonPop/content/images/hints/kacho.png",
	"./kachya.png": "./src/Containers/Play/BalloonPop/content/images/hints/kachya.png",
	"./khuti.png": "./src/Containers/Play/BalloonPop/content/images/hints/khuti.png",
	"./lahara.png": "./src/Containers/Play/BalloonPop/content/images/hints/lahara.png",
	"./maam.png": "./src/Containers/Play/BalloonPop/content/images/hints/maam.png",
	"./maas.png": "./src/Containers/Play/BalloonPop/content/images/hints/maas.png",
	"./maina.png": "./src/Containers/Play/BalloonPop/content/images/hints/maina.png",
	"./meet.png": "./src/Containers/Play/BalloonPop/content/images/hints/meet.png",
	"./mit.png": "./src/Containers/Play/BalloonPop/content/images/hints/mit.png",
	"./mitra.png": "./src/Containers/Play/BalloonPop/content/images/hints/mitra.png",
	"./nani.png": "./src/Containers/Play/BalloonPop/content/images/hints/nani.png",
	"./paat.png": "./src/Containers/Play/BalloonPop/content/images/hints/paat.png",
	"./patthar.png": "./src/Containers/Play/BalloonPop/content/images/hints/patthar.png",
	"./pharsi.png": "./src/Containers/Play/BalloonPop/content/images/hints/pharsi.png",
	"./ping.png": "./src/Containers/Play/BalloonPop/content/images/hints/ping.png",
	"./raati.png": "./src/Containers/Play/BalloonPop/content/images/hints/raati.png",
	"./rang.png": "./src/Containers/Play/BalloonPop/content/images/hints/rang.png",
	"./rukh.png": "./src/Containers/Play/BalloonPop/content/images/hints/rukh.png",
	"./saag.png": "./src/Containers/Play/BalloonPop/content/images/hints/saag.png",
	"./table.png": "./src/Containers/Play/BalloonPop/content/images/hints/table.png",
	"./taxi.png": "./src/Containers/Play/BalloonPop/content/images/hints/taxi.png",
	"./ticket.png": "./src/Containers/Play/BalloonPop/content/images/hints/ticket.png",
	"./tika.png": "./src/Containers/Play/BalloonPop/content/images/hints/tika.png",
	"./veda.png": "./src/Containers/Play/BalloonPop/content/images/hints/veda.png",
	"./water_tap.png": "./src/Containers/Play/BalloonPop/content/images/hints/water_tap.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/BalloonPop/content/images/hints sync recursive ^\\.\\/.*$";